// Parallax portfolio rows — shared by the Web Studio "Selected work" gallery and the
// klikdigital/our-portfolio block, so it runs on every page.
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function initPortfolioParallax() {
  const sections = document.querySelectorAll('.parallax-section');

  if (!sections.length) return;

  // Roll-over labels: the scss ::after prints content: attr(data-hover).
  document.querySelectorAll('.p-card-link').forEach((link) => {
    if (!link.getAttribute('data-hover')) {
      link.setAttribute('data-hover', link.textContent.trim());
    }
  });

  ScrollTrigger.matchMedia({
    '(min-width: 1024px)': function () {
      document.querySelectorAll('.parallax-row').forEach((row) => {
        const direction = row.dataset.direction === 'right' ? 1 : -1;

        gsap.fromTo(
          row,
          { xPercent: direction * 10 },
          {
            xPercent: direction * -10,
            ease: 'none',
            force3D: true,
            scrollTrigger: {
              trigger: row,
              start: 'top bottom',
              end: 'bottom top',
              scrub: 0.5,
              invalidateOnRefresh: true,
            },
          }
        );
      });
    },

    '(max-width: 1023px)': function () {
      const cleanups = [];

      sections.forEach((section) => {
        const rows = Array.from(section.querySelectorAll('.parallax-row'));
        if (rows.length < 2) return;
        if (section.querySelector('.parallax-view-more')) return;

        const hidden = rows.slice(1);
        const cta = section.querySelector('.section-our-portfolio__cta');

        // "View more" replaces the section CTA while rows are collapsed, so
        // only one button is ever on screen.
        const collapse = () => {
          hidden.forEach((row) => { row.style.display = 'none'; });
          if (cta) cta.style.display = 'none';
        };
        const expand = () => {
          hidden.forEach((row) => { row.style.display = ''; });
          if (cta) cta.style.display = '';
        };

        collapse();

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'parallax-view-more';

        // Homepage portfolio uses the Figma "Learn more →" label; Web Studio keeps "View more".
        if (section.classList.contains('section-our-portfolio')) {
          btn.innerHTML = 'Learn more <span class="btn__arrow" aria-hidden="true">→</span>';
        } else {
          btn.textContent = 'View more';
        }

        btn.addEventListener('click', function () {
          expand();
          btn.remove();
          ScrollTrigger.refresh();
        });

        // Keep the button right after the rows, ahead of any section CTA.
        const inner = section.querySelector('.parallax-inner');

        if (inner) {
          inner.insertAdjacentElement('afterend', btn);
        } else {
          section.appendChild(btn);
        }

        cleanups.push(() => {
          btn.remove();
          expand();
        });
      });

      return function () {
        cleanups.forEach((fn) => fn());
      };
    },
  });
}
